module.exports = __webpack_public_path__ + "static/media/Editea_Sorter-1.0.0-magento1.c72133a2.zip";